module.exports = __webpack_public_path__ + "images/emoji/statue_of_liberty.da9042f70a2c67e42c54.png";